import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
const avatarClasses = {
    tiny: 'size-3.5 squircle',
    small: 'size-4 squircle',
    regular: 'size-6 squircle',
    medium: 'size-8 squircle',
    large: 'size-10 squircle',
    xlarge: 'size-14 squircle',
    full: 'size-full',
};
export const ConnectorAvatar = ({ connectorAvatar, name, size = 'large', }) => {
    const avatarClassName = `shrink-0 ${avatarClasses[size]}`;
    const plugIconSize = size === 'xlarge' || size === 'full'
        ? 'large'
        : size === 'large' || size === 'medium' || size === 'regular'
            ? 'medium'
            : 'tiny';
    const iconUrl = connectorAvatar?.trim();
    if (iconUrl) {
        return _jsx("img", { src: iconUrl, alt: name, className: `${avatarClassName} object-contain` });
    }
    return (_jsx("span", { className: `${avatarClassName} flex items-center justify-center bg-subtle`, children: _jsx(Icon, { icon: $icon('plug'), size: plugIconSize }) }));
};
//# sourceMappingURL=ConnectorAvatar.js.map